export const SocialMedia = (value) => {
    if(value == 'facebook'){
        window.open("https://www.facebook.com/share/1EN1DHo2Uw/?mibextid=wwXIfr", "_blank");
    }
    if(value == 'instagram'){
        window.open("https://www.instagram.com/flintinfotech?igsh=MThtd2w3OXJveHdrZA==", "_blank");
    }
}